import React from "react";
import PropTypes from "prop-types";

function NormTable({ label, currentValue, startValue, unit = "" }) {
  // Format the starting value
  const formattedStart =
    startValue !== null && startValue !== undefined && !isNaN(startValue)
      ? `${startValue}${unit}`
      : "N/A";

  // Format the current value
  const formattedCurrent =
    currentValue !== null && currentValue !== undefined && !isNaN(currentValue)
      ? `${currentValue}${unit}`
      : "N/A";

  // Compute delta if both values are valid numbers, then round to 2 decimals.
  const delta =
    startValue !== null &&
    startValue !== undefined &&
    !isNaN(startValue) &&
    currentValue !== null &&
    currentValue !== undefined &&
    !isNaN(currentValue)
      ? currentValue - startValue
      : null;
  const roundedDelta = delta !== null ? Math.round(delta * 100) / 100 : null;
  const formattedDelta =
    roundedDelta !== null
      ? ` (${roundedDelta >= 0 ? "+" : ""}${roundedDelta}${unit})`
      : "";

  return (
    <div className="row align-items-center border-bottom py-2 mb-2">
      <div className="col-md-4 text-start fw-bold">{label}</div>
      <div className="col-md-4 text-start">
        <small className="text-muted">Starting:</small> {formattedStart}
      </div>
      <div className="col-md-4 text-start">
        <small className="text-muted">Current:</small> {formattedCurrent}
        {formattedDelta}
      </div>
    </div>
  );
}

NormTable.propTypes = {
  label: PropTypes.string.isRequired,
  currentValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  startValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unit: PropTypes.string,
};

export default NormTable;
